module.exports = __webpack_public_path__ + "img/united-kingdom.aac0dfef.png";